module.exports = __webpack_public_path__ + "icon-fully-customizable.svg?cc099cea0da2f5ae13aef182c107a854";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/icon-fully-customizable.svg
// module id = 37
// module chunks = 0